import React from "react";

import BookingEditView from "./BookingEditView";

const BookingEdit = ({
  total_amount,
  bookingId,
  fromDate,
  tillDate,
  phoneNo,
  sortField,
  location,
  page,
  limit,
}) => {
  return (
    <BookingEditView
      total_amount={total_amount}
      bookingId={bookingId}
      fromDate={fromDate}
      tillDate={tillDate}
      phoneNo={phoneNo}
      sortField={sortField}
      location={location}
      page={page}
      limit={limit}
    />
  );
};

BookingEdit.propTypes = {};

export default BookingEdit;
